export const Loading = () => {
  return (
    <div className="flex items-center justify-center w-full h-full bg-gray-100 pointer-events-none">
      <p className="tracking-widest text-gray-300 animate-pulse font-title">
        LOADING
      </p>
    </div>
  );
};
